import { render, staticRenderFns } from "./NaviFollowSearchnaviEn.vue?vue&type=template&id=01ecfa16&scoped=true&"
import script from "./NaviFollowSearchnaviEn.vue?vue&type=script&lang=ts&"
export * from "./NaviFollowSearchnaviEn.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=01ecfa16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ecfa16",
  null
  
)

export default component.exports